import React, { useState } from "react";

export default function PerformanceBlock({
  block,
  principles = [],
  responses = {},
  setResponses,
  showToast,
  isReadOnly
}) {



  const updateTableValue = (
    questionCode,
    principleCode,
    field,
    value
  ) => {

    setResponses((prev) => ({
      ...prev,
      table: {
        ...prev.table,

        [questionCode]: {
          ...(prev.table?.[questionCode] || {}),

          [principleCode]: {
            ...(prev.table?.[
              questionCode
            ]?.[
              principleCode
            ] || {}),

            [field]: value
          }
        }
      }
    }));
  };
const updateMatrixTableValue = (
  questionCode,
  principleCode,
  field,
  value
) => {
  setResponses((prev) => ({
    ...prev,
    table: {
      ...prev.table,

      [questionCode]: {
        ...(prev.table?.[questionCode] || {}),

        [principleCode]: {
          ...(prev.table?.[
            questionCode
          ]?.[
            principleCode
          ] || {}),

          [field]: value
        }
      }
    }
  }));
};
const hasAnyPolicyMissing =
  principles.some(
    (p) =>
      responses?.matrix?.Q1A?.[
        p.principle_code
      ] !== "Yes"
  );
  const [editingPrinciple, setEditingPrinciple] =useState(null);
  const [editingAgency, setEditingAgency] =useState(null);

const isPolicyCovered = (principleCode) =>
  responses?.matrix?.Q1A?.[
    principleCode
  ] === "Yes";

  return (
    <div className="performance-block table-card">

      <div className="section_b_title">
        {block.block_title}
      </div>

      {(block.questions || []).map((question) => (

        <div
          key={question.question_code}
          
        >

          <h5
           
          >
            {question.question_code} -{" "}
            {question.question_text}
          </h5>

          {/* Q10 */}

{question.config_json?.table_type ===
  "ngrbc_review" && (

  <>

    {(question.config_json?.subjects || []).map(
      (subject) => (

        <div
          key={subject}
          className="q10-card"
        >

          <div className="q10-subject">
            {subject}
          </div>

          <div className="q10-grid">

            {principles.map((p) => (

              <div
                key={`${subject}_${p.principle_code}`}
                className="q10-item"
              >

                <div className="q10-principle">
                  {p.principle_code}
                </div>

                <label className="q10-label">
                  Review Undertaken
                </label>

                <select
                  className="form-select"
                  disabled={isReadOnly}
                  value={
                    responses?.table?.Q10?.[
                      subject
                    ]?.[
                      p.principle_code
                    ]?.reviewBy || ""
                  }

                  onChange={(e) =>
                    setResponses((prev) => ({
                      ...prev,

                      table: {
                        ...prev.table,

                        Q10: {
                          ...(prev.table?.Q10 || {}),

                          [subject]: {
                            ...(prev.table?.Q10?.[
                              subject
                            ] || {}),

                            [p.principle_code]: {
                              ...(prev.table?.Q10?.[
                                subject
                              ]?.[
                                p.principle_code
                              ] || {}),

                              reviewBy:
                                e.target.value
                            }
                          }
                        }
                      }
                    }))
                  }
                >

                  <option value="">
                    Select
                  </option>

                  {(question.config_json?.review_options || [])
                    .map((option) => (

                      <option
                        key={option}
                        value={option}
                      >
                        {option}
                      </option>

                  ))}

                </select>

                <label
                  className="q10-label"
                  style={{
                    marginTop: "10px"
                  }}
                >
                  Frequency
                </label>

                <select
                  className="form-select"
                  disabled={isReadOnly}
                  value={
                    responses?.table?.Q10?.[
                      subject
                    ]?.[
                      p.principle_code
                    ]?.frequency || ""
                  }

                  onChange={(e) =>
                    setResponses((prev) => ({
                      ...prev,

                      table: {
                        ...prev.table,

                        Q10: {
                          ...(prev.table?.Q10 || {}),

                          [subject]: {
                            ...(prev.table?.Q10?.[
                              subject
                            ] || {}),

                            [p.principle_code]: {
                              ...(prev.table?.Q10?.[
                                subject
                              ]?.[
                                p.principle_code
                              ] || {}),

                              frequency:
                                e.target.value
                            }
                          }
                        }
                      }
                    }))
                  }
                >

                  <option value="">
                    Select
                  </option>

                  {(question.config_json?.frequency_options || [])
                    .map((option) => (

                      <option
                        key={option}
                        value={option}
                      >
                        {option}
                      </option>

                  ))}

                </select>

              </div>

            ))}

          </div>

        </div>

      )
    )}

  </>

)}
{question.config_json?.table_type ===
  "external_assessment" && (

  <table className="table table-bordered">

    <thead>
      <tr>
        <th>Question</th>

        {principles.map((p) => (
          <th key={p.principle_code}>
            {p.principle_code}
          </th>
        ))}
      </tr>
    </thead>

    <tbody>

      <tr>
        <td>
          Assessment Conducted
        </td>

        {principles.map((p) => (

          <td key={p.principle_code}>

            <input
              type="checkbox" className="matrix_checkbox"
              disabled={isReadOnly}
              checked={
                responses?.table?.[
                  question.question_code
                ]?.[
                  p.principle_code
                ]?.yesNo === "Yes"
              }
              onChange={(e) =>
                updateMatrixTableValue(
                  question.question_code,
                  p.principle_code,
                  "yesNo",
                  e.target.checked
                    ? "Yes"
                    : "No"
                )
              }
            />

          </td>

        ))}
      </tr>

      <tr>

  <td>Agency Name</td>

  {principles.map((p) => {

    const agencyName =
      responses?.table?.[
        question.question_code
      ]?.[
        p.principle_code
      ]?.agencyName;

    const isChecked =
      responses?.table?.[
        question.question_code
      ]?.[
        p.principle_code
      ]?.yesNo === "Yes";

    return (

      <td key={p.principle_code}>

        {isChecked ? (

  isReadOnly ? (

    agencyName ? (

      <span
        className="reason-badge saved"
        onClick={() =>
          setEditingAgency(
            p.principle_code
          )
        }
      >
        👁️
      </span>

    ) : (

      <span
        style={{
          color:"#999"
        }}
      >
        N/A
      </span>

    )

  ) : (

    <span
      className={
        agencyName
          ? "reason-badge saved"
          : "reason-badge add"
      }

      onClick={() =>
        setEditingAgency(
          p.principle_code
        )
      }
    >
      {agencyName
        ? "✓"
        : "✏️"}
    </span>

  )

) : (

          <span
            style={{
              color: "#999"
            }}
          >
            N/A
          </span>

        )}

      </td>

    );

  })}

</tr>
<tr><td>&nbsp;</td><td colSpan="9">{editingAgency && (
  <div className="le-card ecf-card agency_box">

    <div className="reason-editor-header">
      {isReadOnly
    ? "View Agency"
    : "Edit Agency"}

  {" - "}

  <strong>
    {editingAgency}
  </strong>
    </div>

    <input type="text"
      className="form-control"
      readOnly={isReadOnly}
      rows={4}
      value={
        responses?.table?.[question.question_code]?.[editingAgency]?.agencyName || ""
      }
      onChange={(e) =>
        updateMatrixTableValue(
          question.question_code,
          editingAgency,
          "agencyName",
          e.target.value
        )
      }
    />

    <div className="ecf-footer">
      <button
        className="org-btn-cancel"
        onClick={() => setEditingAgency(null)}
      >
        Cancel
      </button>
{!isReadOnly && (
      <button className="org-btn-save" onClick={() => {

    const agencyName =
      responses?.table?.[
        question.question_code
      ]?.[
        editingAgency
      ]?.agencyName?.trim();

    if (!agencyName) {

      showToast(
        "Agency Name is required",
        "error"
      );

      return;
    }

    setEditingAgency(null);

  }}
      > Save Agency
</button>
)}
    </div>

  </div>
)}</td></tr>
    </tbody>

  </table>

)}
          {/* Q12 */}

  {hasAnyPolicyMissing && question.config_json?.table_type ===
  "policy_not_covered_reason" && (

  <div className="table-responsive">

    <table className="table table-bordered">

      <thead>
        <tr>
          <th>
            Questions
          </th>

          {principles.map((p) => (
            <th
              key={p.principle_code}
              className="text-center"
            >
              {p.principle_code}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>

        {(question.config_json?.reasons || [])
  .filter(
    (reason) =>
      reason !==
      "Any other reason (please specify)"
  )
  .map((reason) => (

            <tr key={reason}>

              <td>
                {reason}
              </td>

              {principles.map((p) => {

                const checked =
                  responses?.table?.Q12?.[
                    p.principle_code
                  ]?.reason === reason;

                return (

                  <td
                    key={p.principle_code}
                    className="text-center"
                  >
                {isPolicyCovered(
                  p.principle_code
                ) ? (

                  <span
                    style={{
                      color: "#999",
                      fontSize: "12px"
                    }}
                  >
                    N/A
                  </span>

                ) : (
                <>  
    <label className="q10-label">
      Yes
    </label>
                    <input
                      type="radio"
                      className="matrix_checkbox"
                      disabled={isReadOnly}
                      name={`Q12_${p.principle_code}`}

                      checked={checked}

                      onChange={() =>
  setResponses((prev) => ({
    ...prev,

    table: {
      ...prev.table,

      Q12: {
        ...(prev.table?.Q12 || {}),

        [p.principle_code]: {
          ...(prev.table?.Q12?.[
            p.principle_code
          ] || {}),

          reason,
          otherReason: ""
        }
      }
    }
  }))
}
                    />
                    </>
          )}
                  </td>

                );

              })}

            </tr>

          )
        )}
   {/* OTHER REASON TEXTAREA */}
      <tr>

  <td>
    Any other reason (please specify)
  </td>

  {principles.map((p) => {

    const existingReason =
      responses?.table?.Q12?.[
        p.principle_code
      ]?.otherReason;

    return (

      <td
        key={p.principle_code}
        className="text-center"
      >
      {!isPolicyCovered(
  p.principle_code
) ? (

  isReadOnly ? (

    existingReason ? (

      <span
        className="reason-badge saved"
        onClick={() =>
          setEditingPrinciple(
            p.principle_code
          )
        }
      >
        👁️
      </span>

    ) : (

      <span
        style={{
          color: "#999",
          fontSize: "12px"
        }}
      >
        N/A
      </span>

    )

  ) : (

    <span
      className={
        existingReason
          ? "reason-badge saved"
          : "reason-badge add"
      }
      onClick={() => {

  setResponses((prev) => ({
    ...prev,

    table: {
      ...prev.table,

      Q12: {
        ...(prev.table?.Q12 || {}),

        [p.principle_code]: {
          ...(prev.table?.Q12?.[
            p.principle_code
          ] || {}),

          reason: ""
        }
      }
    }
  }));

  setEditingPrinciple(
    p.principle_code
  );

}}
    >
      {existingReason
        ? "✓"
        : "✏️"}
    </span>

  )

) : (

  <span
    style={{
      color:"#999"
    }}
  >
    N/A
  </span>

)}
      </td>

    );

  })}

</tr>
<tr><td>&nbsp;</td><td colSpan="9">{editingPrinciple && (

  <div className="le-card ecf-card">

    <div className="reason-editor-header">

      {isReadOnly
    ? "View Reason"
    : "Edit Reason"}

  {" - "}
      <strong>
        {editingPrinciple}
      </strong>

    </div>

    <textarea
      className="form-control"
      rows={6}
      readOnly={isReadOnly}
      value={
        responses?.table?.Q12?.[
          editingPrinciple
        ]?.otherReason || ""
      }

      onChange={(e) =>
        setResponses((prev) => ({
          ...prev,

          table: {
            ...prev.table,

            Q12: {
              ...(prev.table?.Q12 || {}),

              [editingPrinciple]: {
                ...(prev.table?.Q12?.[
                  editingPrinciple
                ] || {}),

                otherReason:
                  e.target.value
              }
            }
          }
        }))
      }
    />

    <div className="ecf-footer">

<button
        className="org-btn-cancel"
        onClick={() =>
          setEditingPrinciple(null)
        }
      >
        Cancel
      </button>
      {!isReadOnly && (
      <button
  className="org-btn-save"
  onClick={() => {

    const otherReason =
      responses?.table?.Q12?.[
        editingPrinciple
      ]?.otherReason?.trim();

    if (!otherReason) {

      showToast(
        "Other Reason is required",
        "error"
      );

      return;
    }

    setEditingPrinciple(null);

  }}
>
  Save Reason
</button>

      )}

    </div>

  </div>

)}</td></tr>

      </tbody>
       

    </table>



    

  </div>

)}

        </div>

      ))}

    </div>
  );
}